exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.avatar-preview[data-v-c3944cd0] {\n  width: 192px;\n  height: 192px;\n  position: relative;\n  border-radius: 100%;\n  border: 6px solid #F8F8F8;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);\n  margin-bottom: 20px;\n}\n.avatar-preview > div[data-v-c3944cd0] {\n  width: 100%;\n  height: 100%;\n  border-radius: 100%;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n", ""]);

// exports
